<template>
  <div class="p-hsb">
    {{baseData}}
  </div>
</template>

<script>
import {subBannerData} from '../config'
export default {
  name: 'subBanner-component',
  data () {
    return {
      baseData: subBannerData
    }
  }

}
</script>

<style lang="scss" scoped>
.p-hsb{
  min-height: 20vh;
}
</style>